var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelegram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 240,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.66671,
    x2: 0.41671,
    y1: 0.16671,
    y2: 0.75
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37aee2",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1e96c8",
    offset: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    id: "svg_1",
    transform: "scale(3.4682)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "svg_2",
    cy: 34.6,
    cx: 34.6,
    r: 34.6,
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_3",
    d: "m14.4,34.3l23.3,-9.6c2.3,-1 10.1,-4.2 10.1,-4.2s3.6,-1.4 3.3,2c-0.1,1.4 -0.9,6.3 -1.7,11.6l-2.5,15.7s-0.2,2.3 -1.9,2.7c-1.7,0.4 -4.5,-1.4 -5,-1.8c-0.4,-0.3 -7.5,-4.8 -10.1,-7c-0.7,-0.6 -1.5,-1.8 0.1,-3.2c3.6,-3.3 7.9,-7.4 10.5,-10c1.2,-1.2 2.4,-4 -2.6,-0.6l-14.1,9.5s-1.6,1 -4.6,0.1c-3,-0.9 -6.5,-2.1 -6.5,-2.1s-2.4,-1.5 1.7,-3.1z",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/Telegram.fba67de66b28d89cccb192e38b66e7e3.svg";
export { ForwardRef as ReactComponent };